import { GlobalController } from 'src/shared/global/GlobalController'
import ConsentLetter from './ConsentLetter'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'consentLetter',
    component: ConsentLetter,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
